import axios from "axios";
import { OK } from "./constant";
import qs from "qs";
import { getQueryString, unionFlag } from "../utils";
import { bfdApi } from "../utils/constant";
import { Message } from "element-ui";

let appAPI, mallAPI;
const { NODE_ENV, VUE_APP_FLAG } = process.env;

if (NODE_ENV === "production") {
  if (/test\d{2}$/g.test(VUE_APP_FLAG)) {
    if (VUE_APP_FLAG == "test05") {
      // appAPI = "http://www-test05.dongfangfuli.com/gw/app";
      // mallAPI = "http://www-test05.dongfangfuli.com/mallapi";
      appAPI = "/gw/app";
      mallAPI = "/mallapi";
    } else {
      appAPI = `http://appzuul.${VUE_APP_FLAG}.com`;
      mallAPI = `http://api.${VUE_APP_FLAG}.com`;
    }
  } else {
    appAPI = "/gw/app";
    mallAPI = "/mallapi";
  }
} else {
  // appAPI = "http://appzuul.test01.com";
  // mallAPI = "http://api.test01.com";
  // appAPI = "http://www.dongfangfuli.com/gw/app";
  // mallAPI = "http://www.dongfangfuli.com/mallapi";
  appAPI = "/gw/app";
  mallAPI = "/mallapi";
}

/**
 * 创建一个axios实例
 */
const _axios = axios.create();

// 请求前添加拦截器
const _axios_req = _axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // const union = getQueryString("union");
    const union = unionFlag();
    let city = getQueryString("city");
    if (city.indexOf("?") >= 0) {
      city = city.slice(0, city.indexOf("?"));
    }
    let params;

    if (union) {
      params = {
        platform: 0,
        unionFlag: 1,
        union,
        cityId: Number(city),
        city: Number(city),
      };

      config.data = { ...params, ...config.data };
    } else {
      params = {
        platform: 0,
        city: city,
      };
      config.data = { ...params, ...config.data };
    }

    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应后添加拦截器
const _axios_res = _axios.interceptors.response.use(function (response) {
  // 响应成功的正确处理
  if (
    Number(response.data.respCode) === OK ||
    Number(response.data.code) === OK ||
    response.data.respCode == "666666" ||
    response.data.respCode == "555555" ||
    response.data.code == 101002 ||
    response.data.code == 10000 ||
    response.data.code == 101003 ||
    response.data.code == 200 ||
    response.data.code == 'BFF000000'
  ) {
    return response.data;
  }

  // 响应成功的错误处理
  return Promise.reject({
    code: response.data.code,
    msg: response.data.msg,
  });
});

/**
 * 封装获取数据的请求方法
 * @param  { String }  url    接口路径
 * @param  { Object }  params 请求的参数
 * @param  { Boolean } immediate 区别mallAPI和appAPI接口
 * @param  { Boolean } bfdURL 是否为百福得bfdApi = `//${unionFlag()}-corp${envMap[API_ENV]}.dongfangfuli.com`下接口
 * @param  { String }  method 默认POST, 区别POST/GET方式
 * @return { Promise }
 */
export function sendPost(url, params, immediate, bfdURL, method, baseURLStr) {
  const getBaseURL = () => {
    if (typeof baseURLStr === 'string') return baseURLStr;
    if (bfdURL) return bfdApi;
    if (immediate) return mallAPI;
    return appAPI;
  };

  return _axios({
    url,
    method: method ? method : "post",
    data: params,
    baseURL: getBaseURL(),
    transformRequest: [
      function (data) {
        return immediate
          ? qs.stringify(data, { allowDots: true })
          : JSON.stringify(data);
      },
    ],
    headers: {
      "Content-Type": immediate
        ? "application/x-www-form-urlencoded"
        : "application/json",
      "Business-Type": 1,
    },
    timeout: 6000,
    withCredentials: true,
  }).catch((err) => {
    // gio不验证
    if (
      err.config.url.indexOf("api.growingio") > -1 ||
      err.config.url.indexOf("/usercoord/usercard/external/validate") > -1
    ) {
      return;
    }
    Message({
      type: "error",
      message: !err.msg ? "无数据" : err.msg,
    });
  });
}

export { _axios, _axios_req, _axios_res };
